export const convertIdToNumber = (id: number | string): number =>
  typeof id === "number" ? id : parseInt(id);
